import { createSlice } from "@reduxjs/toolkit";
import { authenticateUserThunk } from "./Login.Thunk";
import { v4 as uuidv4 } from "uuid";
import {
  setEncryptedItem,
  getDecryptedItem,
  removeItem,
  clearEncryptedStorage,
} from "../../utils/storageUtils";

const initialState = {
  data: [],
  loggedin: getDecryptedItem("loggedin") === true,
  loading: false,
  status: "",
  message: "",
};

const LoginSlice = createSlice({
  name: "loginslice",
  initialState,
  reducers: {
    check_login_status(state) {
      state.loggedin = getDecryptedItem("loggedin") === true;
    },
    logout(state) {
      const uniqueId = getDecryptedItem("uniqueId");
      clearEncryptedStorage(["uniqueId"]);
      setEncryptedItem("uniqueId", uniqueId);
      state.loggedin = false;
      state.message = "Logout success";
    },
  },
  extraReducers: {
    [authenticateUserThunk.pending]: (state, action) => {
      state.data = [];
      state.loggedin = false;
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [authenticateUserThunk.fulfilled]: (state, action) => {
      const payload = action.payload;
      state.data = payload;
      state.loading = false;
      state.status = action.meta.requestStatus;

      if (payload.approvalStatus === "approved") {
        state.loggedin = true;
        state.message = "Login success";

        // Encrypt user data
        setEncryptedItem("usertype", payload.usertype);
        setEncryptedItem("username", payload.username);
        setEncryptedItem("userid", payload.userid);
        setEncryptedItem("password", payload.password);
        setEncryptedItem("approvalStatus", payload.approvalStatus);
        setEncryptedItem("loggedin", true);

        if (!getDecryptedItem("uniqueId")) {
          const newUuid = uuidv4();
          setEncryptedItem("uniqueId", newUuid);
        }
      } else {
        state.loggedin = false;
        state.message = "Invalid userid/ password";
        clearEncryptedStorage(["uniqueId"]);
      }
    },
    [authenticateUserThunk.rejected]: (state, action) => {
      state.data = [];
      state.loggedin = false;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
      clearEncryptedStorage(["uniqueId"]);
    },
  },
});

export const { check_login_status, logout } = LoginSlice.actions;
export default LoginSlice.reducer;
